import { columns, columns2 } from "views/RoutesStatus/columns";
import { deepFreeze } from "./deepFreeze";

export const imageOrderDetailType = {
  INITIAL: "Antes",
  FINAL: "Después",
  REMOTE: "Remoto",
};

export const modals = {
  customer: "customer",
  address: "address",
  cancel: "cancel",
};

export const defaultValuesCrm = {
  account: {
    type: "ESTACIONARIO",
    segment: "AUTOTANQUE",
    subsegment: "DOMESTICO",
  },
};

export const measures = {
  CILINDRO: "CILINDRO",
  LITROS: "LTS",
};

export const typesUnit = [
  { value: 1, label: "ESTACIONARIO" },
  // { value: 2, label: "ESTACION" },
  { value: 2, label: "PORTATIL" },
];

export const segmentsVariables = {
  ESTACIONARIO: {
    value: 1,
    label: "AUTOTANQUE",
    type: "ESTACIONARIO",
    subsegments: [
      { value: 1, label: "DOMESTICO" },
      { value: 2, label: "GOBIERNO" },
      { value: 3, label: "HOSPITALES PRIVADOS" },
      { value: 4, label: "INDUSTRIAL" },
      { value: 4, label: "TORTILLERIAS" },
    ],
  },
  // ESTACION: {
  //   value: 2,
  //   label: "CARBURACION",
  //   type: "ESTACION",
  //   subsegments: [{ value: 1, label: "PIGTELEO" }],
  // },
  PORTATIL: {
    value: 2,
    label: "CILINDRO",
    types: "PORTATIL",
    subsegments: [
      { value: 1, label: "INDUSTRIAL" },
      { value: 2, label: "RESIDENCIAL" },
    ],
  },
};

export const typesUnitsOpt = [
  { value: "ESTACIONARIO", label: "ESTACIONARIO" },
  { value: "PORTATIL", label: "PORTATIL" },
  { value: "ESTACION", label: "ESTACION" },
  { value: "AUTOTANQUE", label: "AUTOTANQUE" },
  { value: "MAYORISTA_E", label: "MAYORISTA_E" },
  { value: "MAYORISTA_P", label: "MAYORISTA_P" },
];

export const segmentsTypesOpt = [
  {
    value: "AUTOTANQUE",
    label: "AUTOTANQUE",
    type: "ESTACIONARIO",
    subsegments: [
      { value: "DOMESTICO", label: "DOMESTICO" },
      { value: "GOBIERNO", label: "GOBIERNO" },
      { value: "HOSPITALES PRIVADOS", label: "HOSPITALES PRIVADOS" },
      { value: "INDUSTRIAL", label: "INDUSTRIAL" },
      { value: "TORTILLERIAS", label: "TORTILLERIAS" },
    ],
  },
  {
    value: "CILINDRO",
    label: "CILINDRO",
    type: "PORTATIL",
    subsegments: [
      { value: "INDUSTRIAL", label: "INDUSTRIAL" },
      { value: "RESIDENCIAL", label: "RESIDENCIAL" },
      { value: "CILINDRERA", label: "CILINDRERA" },
    ],
  },
];

export const TAXIS_STATES = {
  TAXI: {
    name: "TAXI",
    label: "Ocupado",
  },
  FREE: {
    name: "FREE",
    label: "Libre",
  },
  BLOCKED: {
    name: "BLOCKED",
    label: "Bloqueado",
  },
};

export const inventoryStatus = {
  NOT_EXISTS: "NOT_EXISTS",
  OPEN: "OPEN",
  CLOSED: "CLOSED",
};

export const gasMovementsStatus = {
  GAS_MOVEMENT: "GAS_MOVEMENT",
};

export const commonRfc = "XAXA010101XXX";

export const liquidationStatus = {
  label: {
    READY: "Pendiente",
    DELETED: "Eliminada",
    CONFIRMED: "SGC",
    CANCELED: "Cancelada",
    SAVED: "Creada",
    ON_HOLD: "En Espera",
  },
  value: {
    READY: "READY",
    DELETED: "DELETED",
    CONFIRMED: "CONFIRMED",
    CANCELED: "CANCELED",
    SAVED: "SAVED",
    ON_HOLD: "ON_HOLD",
  },
};

export const routesTypes = [
  {
    value: "PORTATIL",
    label: "Portatil",
    cols: columns,
  },
  {
    value: "ESTACIONARIO",
    label: "Estacionario",
    cols: columns,
  },
  {
    value: "ESTACION",
    label: "Estación",
    cols: columns2,
  },
];

export const inventoryDictionary = {
  local: "localInventory",
  mobile: "mobileInventory",
  shipment: "shipmentInventory",
  storages: "storagesInventory",
  stationary: "stationaryInventory",
};

export const monthsDictionary = [
  {
    id: "01",
    label: "Enero",
    value: 1,
  },
  {
    id: "02",
    label: "Febrero",
    value: 2,
  },
  {
    id: "03",
    label: "Marzo",
    value: 3,
  },
  {
    id: "04",
    label: "Abril",
    value: 4,
  },
  {
    id: "05",
    label: "Mayo",
    value: 5,
  },
  {
    id: "06",
    label: "Junio",
    value: 6,
  },
  {
    id: "07",
    label: "Julio",
    value: 7,
  },
  {
    id: "08",
    label: "Agosto",
    value: 8,
  },
  {
    id: "09",
    label: "Septiembre",
    value: 9,
  },
  {
    id: "10",
    label: "Octubre",
    value: 10,
  },
  {
    id: "11",
    label: "Noviembre",
    value: 11,
  },
  {
    id: "12",
    label: "Diciembre",
    value: 12,
  },
];

  export const tankTypeDictionary = [
    {
      value: 'VENTA',
      label: 'Venta'
    },
    {
      value: 'CARBURACION',
      label: 'Carburación'
    },
    {
      value: 'TRASPASO',
      label: 'Traspaso'
    }
  ]

export const customersTypeSearch = [
  {
    label: "Clientes",
    value: "customers",
  },
  {
    label: "Mayoristas",
    value: "wholesalers",
  },
  {
    label: "Creditos",
    value: "erp",
  },
];

export const conditionMetricUnit = [
  {
    value: "N/A",
    label: "N/A",
  },
  {
    value: "$",
    label: "$",
  },
  {
    value: "Litros",
    label: "LITROS",
  },
  {
    value: "SI",
    label: "SI",
  },
  {
    value: "NO",
    label: "NO",
  },
  {
    value: "Kilos",
    label: "KILOS",
  },
  {
    value: "Pieza",
    label: "PIEZA",
  },
  {
    value: "Unidad",
    label: "UNIDAD",
  },
  {
    value: "%",
    label: "%",
  },
];
export const ivaOptions = [
  {
    label: "16%",
    value: 0.16,
    value2: "0.16",
  },
  {
    label: "8%",
    value: 0.08,
    value2: "0.08",
  },
];

export const decimalsOptions = [
  {
    label: "6 decimales",
    value: 6,
  },
  {
    label: "4 decimales",
    value: 4,
  },
  {
    label: "2 decimales",
    value: 2,
  },
];

export const conceptOpt = [
  {
    label: "AGRUPADO",
    value: "AGRUPADO",
    val: true,
  },
  {
    label: "DESGLOSADO",
    value: "DESGLOSADO",
    val: false,
  },
];

export const paymentsInvoicesType = [
  {
    label: "PPD",
    value: "PPD",
  },
  {
    label: "PUE",
    value: "PUE",
  },
];

export const deliveryTypeOpt = [
  {
    value: "CASA",
    label: "CASA",
  },
  {
    value: "COMISIONISTA",
    label: "COMISIONISTA",
  },
];

export const fuelTypeOpt = [
  {
    value: "GASLP",
    label: "GASLP",
  },
  {
    value: "GASOLINA",
    label: "GASOLINA",
  },
  {
    value: "DIESEL",
    label: "DIESEL",
  },
  {
    value: "ELECTRICO",
    label: "ELECTRICO",
  },
];

export const unitsTypesObj = deepFreeze({
  ESTACIONARIO: "ESTACIONARIO",
  ESTACION: "ESTACION",
  AUTOTANQUE: "AUTOTANQUE",
  PORTATIL: "PORTATIL",
});

export const FILLING_ORDER_STATUS_TYPES = deepFreeze({
  CANCELED: 'CANCELADA',
  CLOSING_DOCK: 'CERRANDO_ANDEN',
  DOWNLOADED: 'DESCARGADA',
  NOT_FOUND: 'NO_ENCONTRADA',
  OPENING_DOCK: 'ABRIENDO_ANDEN',
  PARTIALLY_DOWNLOADED: 'DESCARGADA_PARCIALMENTE', 
  PENDING: 'PENDIENTE',
  PRECANCELED: 'PRECANCELADA',
  REASSIGNING: 'REASIGNANDO',  
  REJECTED: 'RECHAZADA',
  SUBMITTED: 'ENVIADA',  
});

export const SETTLEMENT_TYPES = deepFreeze({
  SETTLEMENT: {
    apiType: 'SETTLEMENT',
    code: 'G',
    label: 'Liquidación', 
  },
  STATION_SALE: {
    apiType: 'STATION_SALE',
    code: 'P',
    label: 'Venta Planta',   
  },
});

export const orderOriginOptions = deepFreeze([
  { value: "CALL", label: "Llamada" },
  { value: "WHATSAPP", label: "Whatsapp" },
  { value: "APP", label: "App" },
  { value: "CALL_LEAD", label: "Llamada Lead" },
  { value: "WHATSAPP_LEAD", label: "Whatsapp Lead" },
  { value: "PRESALE", label: "Preventa" },
  { value: "PRESALE_ROUTE", label: "Preventa en Ruta" },
  { value: "ACCOUNT", label: "Cuenta" },
  { value: "OTHER", label: "Otro" },
  { value: "CALL_BOT", label: "Bot Llamada" },
]);

export const originLabelMap = Object.fromEntries(
  orderOriginOptions.map(({ value, label }) => [value, label])
);

export const PAYMENT_METHODS = deepFreeze({
  CASH: "CASH",
});

export const MAX_DATE_RANGE_DAYS = 31;

// Longitud estándar de un VIN (Vehicle Identification Number).
export const VIN_LENGTH = 17;
